import { render } from "./porsesh.vue?vue&type=template&id=b4f8530e"
import script from "./porsesh.vue?vue&type=script&lang=js"
export * from "./porsesh.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__